import { render, staticRenderFns } from "./HeroBranding.vue?vue&type=template&id=d3c7d79a&scoped=true&"
import script from "./HeroBranding.vue?vue&type=script&lang=js&"
export * from "./HeroBranding.vue?vue&type=script&lang=js&"
import style0 from "./HeroBranding.vue?vue&type=style&index=0&id=d3c7d79a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c7d79a",
  null
  
)

export default component.exports